import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Features } from '../components/sections/Features';
import { SocialProof } from '../components/sections/SocialProof';
import { ProblemSolution } from '../components/sections/ProblemSolution';
import { CourseDetails } from '../components/sections/CourseDetails';
import { FooterCTA } from '../components/sections/FooterCTA';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
export function Landing() {
  return <main className="min-h-screen bg-bg-primary text-text-primary" data-id="element-287">
      <Hero data-id="element-288" />
      <Features data-id="element-289" />
      <SocialProof data-id="element-290" />
      <ProblemSolution data-id="element-291" />
      <CourseDetails data-id="element-292" />
      <FooterCTA data-id="element-293" />
      <PurchaseNotifications data-id="element-294" />
    </main>;
}